
export const getMediaDuration = (file: File): Promise<number> => {
  return new Promise((resolve) => {
    const element = file.type.startsWith('video') 
      ? document.createElement('video') 
      : document.createElement('audio');
    
    element.preload = 'metadata';
    element.onloadedmetadata = () => {
      URL.revokeObjectURL(element.src);
      // Duration is in seconds, convert to ms
      if (element.duration && !isNaN(element.duration) && element.duration !== Infinity) {
          resolve(Math.round(element.duration * 1000));
      } else {
          resolve(0);
      }
    };
    
    element.onerror = () => {
        URL.revokeObjectURL(element.src);
        resolve(0); // Fallback
    }
    
    element.src = URL.createObjectURL(file);
  });
};

export const formatTime = (ms: number): string => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};
